import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './SectionHeading.css'

import Heading from '../Heading'

class SectionHeading extends Component {
  render () {
    let imageElement = null
    if (this.props.image) {
      imageElement = (<span className={'hw-esdp-section-heading-image ' + styles.esdp_section_heading_image}>
        {this.props.image}
      </span>)
    }

    let headingElement = (<div className={'hw-esdp-section-heading ' + styles.esdp_section_heading}>
      {imageElement}
      <Heading tabIndex="-1" headingLevel={2} styleLevel={1} className={'hw-esdp-heading ' + styles.heading}>{ this.props.children }</Heading>
    </div>)

    return headingElement
  }
}

SectionHeading.propTypes = {
  children: PropTypes.node.isRequired,
  image: PropTypes.node
}

export default SectionHeading



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/SectionHeading/index.js